import { useState, useEffect } from 'react';
import heroImage from '../../../assets/images/heroDigitalTransformation.jpg';
import backgroundImage from '../../../assets/images/bgHeroDigitalTransformation.jpg';

export default function Hero() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const scrollToContact = () => {
    document.getElementById('contact-section')?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToCapabilities = () => {
    document.getElementById('capabilities-section')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen overflow-hidden bg-gradient-to-br from-slate-50 via-white to-teal-50/80">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={backgroundImage}
          alt=""
          className="h-full w-full object-cover object-center opacity-25"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-white/50 via-transparent to-white/70" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 sm:px-8 lg:px-10 min-h-screen flex items-center py-20 lg:py-24">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center w-full">
          {/* Left: Copy – staggered transition như Skill Hub */}
          <div className="text-center lg:text-left space-y-8">
            <div
              className={`inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/90 backdrop-blur-sm border border-teal-200/80 shadow-sm transition-all duration-1000 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'
              }`}
            >
              <i className="ri-verified-badge-fill text-teal-600 text-lg" />
              <span className="text-sm font-semibold text-slate-700">Tư vấn độc lập & Khách quan</span>
            </div>

            <div
              className={`space-y-4 transition-all duration-1000 delay-200 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
            >
              <h1 className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold leading-[1.15] tracking-tight">
                <span className="block text-slate-800">Chiến lược đúng</span>
                <span className="block text-slate-800 mt-1 lg:mt-2">Triển khai chuẩn</span>
                <span className="block mt-1 lg:mt-2 bg-gradient-to-r from-teal-600 to-emerald-600 bg-clip-text text-transparent">Vận hành an toàn</span>
              </h1>
            </div>

            <div
              className={`transition-all duration-1000 delay-400 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
            >
              <p className="text-lg sm:text-xl text-slate-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
                Chúng tôi cung cấp dịch vụ tư vấn chuyển đổi số toàn diện, giúp tổ chức xây dựng hệ thống số{' '}
                <strong className="font-semibold text-slate-800">bài bản, tuân thủ tiêu chuẩn và bền vững dài hạn</strong>.
              </p>
            </div>

            <div
              className={`flex flex-wrap justify-center lg:justify-start gap-4 pt-2 transition-all duration-1000 delay-600 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
            >
              <button
                onClick={scrollToContact}
                className="group inline-flex items-center gap-2 px-8 py-4 rounded-full font-semibold text-white bg-gradient-to-r from-teal-600 to-emerald-600 shadow-lg hover:shadow-xl hover:scale-[1.02] transition-all duration-300 cursor-pointer"
              >
                Đăng ký tư vấn
                <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform" />
              </button>
              <button
                onClick={scrollToCapabilities}
                className="inline-flex items-center gap-2 px-8 py-4 rounded-full font-semibold text-slate-700 bg-white/90 backdrop-blur-sm border-2 border-slate-200 hover:border-teal-400 hover:text-teal-700 transition-all duration-300 cursor-pointer"
              >
                Tìm hiểu thêm
              </button>
            </div>
          </div>

          {/* Right: Khung – slide từ phải, delay 500ms như Skill Hub */}
          <div
            className={`relative hidden lg:block pl-4 transition-all duration-1000 delay-500 ${
              isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'
            }`}
          >
            <div className="relative w-full aspect-square">
              <div className="absolute inset-0 border-[20px] border-white rounded-2xl rotate-3 shadow-lg" />
              <div className="absolute inset-12 rounded-2xl -rotate-6 overflow-hidden flex items-center justify-center border-8 border-white bg-white shadow-inner">
                <img
                  src={heroImage}
                  alt="Chuyển đổi số doanh nghiệp"
                  className="absolute inset-0 w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-primary/10" />
                <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                  <div className="grid grid-cols-4 gap-4 opacity-20">
                    <div className="w-20 h-20 bg-primary rounded-full" />
                    <div className="w-20 h-20 bg-cyan-500 rounded-full translate-y-10" />
                    <div className="w-20 h-20 border-4 border-primary rounded-full" />
                    <div className="w-20 h-20 bg-primary rounded-full -translate-y-5" />
                  </div>
                </div>
              </div>
              <div className="absolute top-0 right-0 w-32 h-32 bg-cyan-500/10 blur-3xl" />
              <div className="absolute bottom-1/4 left-0 w-64 p-6 sm:p-8 bg-white border border-slate-100 shadow-2xl rounded-xl">
                <span className="text-cyan-500 font-black text-4xl block mb-2">94%</span>
                <p className="text-[10px] text-slate-400 font-bold uppercase tracking-widest">
                  Hiệu quả vận hành sau chuyển đổi
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
